import { FunctionComponent } from 'react';
import { IconHandler } from '../../utils';
import { PaginaInicialTimelineItemType } from '../../types';

const PaginaInicialTimelineItem: FunctionComponent<PaginaInicialTimelineItemType> = ({
  stepIcon,
  stepNumber,
  heading,
  description = '',
}) => {
  return (
    <li className={(stepNumber % 2 !== 0 ? 'timeline-item' : 'timeline-item-inverted') + ' position-relative'}>
      <div className="timeline-image translate-middle">
        <IconHandler Icon={stepIcon} className={'position-absolute start-50 top-50 translate-middle timeline-icon'} />
        <span
          className={
            'position-absolute top-0 ' +
            (stepNumber % 2 !== 0 ? 'start-0' : 'start-100') +
            ' translate-middle badge rounded-circle bg-secondary'
          }
        >
          {stepNumber}
        </span>
      </div>
      <div className="timeline-panel ">
        <div className="timeline-heading">
          <h4>{heading}</h4>
        </div>
        {description && (
          <div className="timeline-body">
            <p className="text-muted">{description}</p>
          </div>
        )}
      </div>
    </li>
  );
};

export default PaginaInicialTimelineItem;
